module.exports = __webpack_public_path__ + "img/Ribbon.891428bd.svg";